(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[581],{

/***/ 63312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/rewards",
      function () {
        return __webpack_require__(12095);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ rewards; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/account/loyaltyAccessor/index.tsx
var loyaltyAccessor = __webpack_require__(51319);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(56580);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/analytics/events/index.ts + 4 modules
var events = __webpack_require__(45003);
// EXTERNAL MODULE: ./src/analytics/events/constants.ts
var constants = __webpack_require__(45048);
// EXTERNAL MODULE: ./src/components/cmsConfig/stringAccessor/index.tsx
var stringAccessor = __webpack_require__(90836);
// EXTERNAL MODULE: ./src/components/uielements/primaryButton/styles.tsx
var styles = __webpack_require__(25167);
// EXTERNAL MODULE: ./src/constants/routes.ts
var routes = __webpack_require__(25643);
;// CONCATENATED MODULE: ./src/components/account/rewards/orderNowCTA/index.tsx







var OrderNowCTA = function(param) {
    var label = param.label;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: {
            pathname: routes/* ROUTES.LOCATIONS */.Z6.LOCATIONS
        },
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledPrimaryButton */.D, {
            "aria-label": "Go to the store locator page",
            onClick: function() {
                (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.GENERIC__CTA */.x.GENERIC__CTA, {
                    name: constants/* EventNames.ORDER_NOW */.V.ORDER_NOW,
                    details: label
                });
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                accessor: "rewards.order_now_button"
            })
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./src/components/content/stitches.ts
var stitches = __webpack_require__(65465);
// EXTERNAL MODULE: ./src/components/image/index.tsx
var components_image = __webpack_require__(79743);
// EXTERNAL MODULE: ./src/components/ui/index.ts + 5 modules
var ui = __webpack_require__(49586);
// EXTERNAL MODULE: ./src/redux/cmsConfig/index.ts
var cmsConfig = __webpack_require__(26738);
// EXTERNAL MODULE: ./src/redux/cmsConfig/utils.ts
var utils = __webpack_require__(73393);
;// CONCATENATED MODULE: ./src/components/account/social-cause-item/social-cause-item.tsx






function SocialCauseItem(param) {
    var name = param.name, description = param.description, image_url = param.image_url, onClick = param.onClick, id = param.id, isSelected = param.isSelected;
    var ref = (0,cmsConfig/* useConfigOverride */.$E)("global"), primary_border_color = ref.primary_border_color, border_radius = ref.border_radius, primary_active_color = ref.primary_active_color;
    var primary_font = (0,cmsConfig/* useConfigOverride */.$E)("text").primary_font;
    var color = (0,utils/* getFontStyles */.l)(primary_font).color;
    var handleClick = function() {
        if (isSelected) {
            onClick();
        } else {
            onClick(id);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Stack */.Kq, {
        "data-testid": "social-cause-item",
        onClick: handleClick,
        direction: "vertical",
        align: "center",
        position: "center",
        css: {
            padding: "$4",
            border: "1px solid ".concat(isSelected ? primary_active_color : primary_border_color),
            borderRadius: "".concat(border_radius, "px"),
            color: color,
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Stack */.Kq, {
                align: "center",
                position: "leading",
                gap: "$4",
                css: {
                    width: "100%"
                },
                children: [
                    image_url ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* Image */.E, {
                        src: image_url,
                        width: 50,
                        height: 50,
                        alt: "".concat(name !== null && name !== void 0 ? name : "", " social cause icon")
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: name
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                children: description
            })
        ]
    });
}
var Description = (0,stitches/* styled */.zo)("p", {
    margin: 0
});

// EXTERNAL MODULE: ../../packages/sdk/dist/v4/index.mjs + 8 modules
var v4 = __webpack_require__(40024);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 6 modules
var useQuery = __webpack_require__(47661);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(62350);
// EXTERNAL MODULE: ./src/features/configs/strings.ts
var configs_strings = __webpack_require__(18971);
// EXTERNAL MODULE: ./src/redux/global/reducer.ts
var reducer = __webpack_require__(83626);
// EXTERNAL MODULE: ./src/redux/me/actions.ts
var actions = __webpack_require__(47290);
// EXTERNAL MODULE: ./src/services/client.ts
var services_client = __webpack_require__(49741);
// EXTERNAL MODULE: ./src/utils/index.ts
var src_utils = __webpack_require__(32210);
// EXTERNAL MODULE: ./src/utils/errorReporter.ts
var errorReporter = __webpack_require__(19663);
// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(36304);
// EXTERNAL MODULE: ./src/utils/stringHelpers.ts
var stringHelpers = __webpack_require__(60738);
;// CONCATENATED MODULE: ./src/components/account/social-causes-modal/social-causes-modal-hooks.ts












var useSocialCauses = function() {
    var client = (0,services_client/* createHttpClient */.d9)({
        origin: (0,src_utils/* getOrigin */.P$)(window.location.host)
    });
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            "social-causes"
        ],
        queryFn: function() {
            return (0,v4/* fetchSocialCauses */.sX)({
                client: client
            });
        },
        refetchOnWindowFocus: false
    });
};
var useDonateToSocialCause = function() {
    var ref = (0,reducer/* useGlobalDispatch */.xP)(), dispatch = ref.dispatch, displayErrorToast = ref.displayErrorToast, displayToast = ref.displayToast;
    var strings = (0,configs_strings/* useStrings */.E)();
    var client = (0,services_client/* createHttpClient */.d9)({
        origin: (0,src_utils/* getOrigin */.P$)(window.location.host)
    });
    return (0,useMutation/* useMutation */.D)(function(input) {
        return (0,v4/* donateToSocialCause */.rJ)(input.socialCause.id, input.donation, {
            client: client
        });
    }, {
        onError: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(error) {
                var errorMessage;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            errorReporter/* captureException */.Tb(error);
                            return [
                                4,
                                (0,global/* prepareErrorMessage */.Xr)((0,stringHelpers/* safelyGetString */.bc)(strings, "rewards.donate_reward_error_text"), error)
                            ];
                        case 1:
                            errorMessage = _state.sent();
                            dispatch(displayErrorToast(errorMessage.message));
                            return [
                                2
                            ];
                    }
                });
            });
            return function(error) {
                return _ref.apply(this, arguments);
            };
        }(),
        onSuccess: function(_data, variables) {
            // If user has successfully donated to a social cause, we need to refetch rewards to update the UI
            dispatch(actions/* default.fetchRedeemables */.Z.fetchRedeemables());
            dispatch(actions/* default.fetchOffers */.Z.fetchOffers());
            dispatch(actions/* default.fetchLoyaltyState */.Z.fetchLoyaltyState());
            dispatch(displayToast((0,stringHelpers/* safelyGetString */.bc)(strings, "rewards.donate_reward_success_text", {
                socialCauseName: variables.socialCause.name
            })));
        }
    });
};

// EXTERNAL MODULE: ./src/components/uielements/modal/index.tsx + 9 modules
var modal = __webpack_require__(84247);
// EXTERNAL MODULE: ./src/components/uielements/render.tsx
var render = __webpack_require__(45190);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(86879);
;// CONCATENATED MODULE: ./src/components/account/social-causes-modal/social-causes-modal.tsx


















function SocialCausesModal(param) {
    var toggle = param.toggle, onSubmit = param.onSubmit, isLoading = param.isLoading;
    var ref = useSocialCauses(), data = ref.data, status = ref.status;
    var label = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.organization.organization;
    }).label;
    var ref1 = (0,react.useState)(), selectedSocialCauseId = ref1[0], setSelectedSocialCauseId = ref1[1];
    var ref2 = (0,reducer/* useGlobalDispatch */.xP)(), dispatch = ref2.dispatch, displayErrorToast = ref2.displayErrorToast;
    if (status === "error") {
        null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Title */.u.Title, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                    accessor: "rewards.donate_reward_modal_header",
                    dataObj: {
                        brand: label
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Content */.u.Content, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Stack */.Kq, {
                    direction: "vertical",
                    gap: "$4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                            condition: status === "loading",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                children: "Fetching Social Causes..."
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                            condition: Boolean((data === null || data === void 0 ? void 0 : data.data) && data.data.length === 0),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                children: " Sorry, there are no Social Causes available "
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                            condition: Boolean((data === null || data === void 0 ? void 0 : data.data) && data.data.length > 0),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitle, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                            accessor: "rewards.donate_reward_modal_subheader"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Stack */.Kq, {
                                        position: "center",
                                        css: {
                                            flexWrap: "wrap"
                                        },
                                        children: data === null || data === void 0 ? void 0 : data.data.map(function(cause) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialCauseItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                isSelected: cause.id === selectedSocialCauseId
                                            }, cause), {
                                                onClick: setSelectedSocialCauseId
                                            }), cause.id);
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Footer */.u.Footer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Cancel */.u.Cancel, {
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledPrimaryButton */.D, {
                        disabled: !selectedSocialCauseId || isLoading || status === "loading",
                        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            var socialCause, error, errorMessage;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!selectedSocialCauseId) {
                                            return [
                                                2
                                            ];
                                        }
                                        socialCause = data === null || data === void 0 ? void 0 : data.data.find(function(cause) {
                                            return cause.id === selectedSocialCauseId;
                                        });
                                        if (!socialCause) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            onSubmit({
                                                id: socialCause.id,
                                                name: socialCause.name
                                            })
                                        ];
                                    case 1:
                                        _state.sent();
                                        toggle();
                                        return [
                                            3,
                                            4
                                        ];
                                    case 2:
                                        error = new Error("Social Cause not found");
                                        errorReporter/* captureException */.Tb(error);
                                        return [
                                            4,
                                            (0,global/* prepareErrorMessage */.Xr)("Social Cause not found. Please try again.", error)
                                        ];
                                    case 3:
                                        errorMessage = _state.sent();
                                        dispatch(displayErrorToast(errorMessage.message));
                                        _state.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                            accessor: "rewards.donate_reward_modal_donate_button"
                        })
                    })
                ]
            })
        ]
    });
}
var SubTitle = (0,stitches/* styled */.zo)("h2", {
    margin: 0
});
var Paragraph = (0,stitches/* styled */.zo)("p", {
    margin: 0,
    textAlign: "center"
});

// EXTERNAL MODULE: ./src/components/uielements/reward/styles.tsx
var reward_styles = __webpack_require__(135);
// EXTERNAL MODULE: ./src/redux/organization/reducer.ts
var organization_reducer = __webpack_require__(63212);
;// CONCATENATED MODULE: ./src/components/account/rewards/donate-to-social-cause/donate-to-social-cause.tsx














/**
 * This component is used to render a button that opens a modal to donate a reward
 *
 * @param donation - Donation object.
 * Where "item" value is:
 * - if "type" is "currency" - $ amount that needs to be donated
 * - if "type" is "reward" - reward_id of the reward that needs to be donated.
 * - if "type" is "redeemable" - redeemable_id of the redeemable that needs to be donated.
 * @param rewardName - Name of the reward
 */ function DonateToSocialCause(param) {
    var donation = param.donation, rewardName = param.rewardName;
    var ref;
    var webConfig = (0,cmsConfig/* useWebConfig */.JR)();
    var organization = (0,redux/* useSelector */.v9)(organization_reducer/* organizationSliceSelector */.F5);
    var ref1 = useDonateToSocialCause(), donateToSocialCause = ref1.mutateAsync, isLoading = ref1.isLoading;
    var isDonatableRewardsEnabled = ((ref = organization.loyalty.features) === null || ref === void 0 ? void 0 : ref.supportsSocialCauses) && webConfig.rewards.donatable_rewards;
    if (!isDonatableRewardsEnabled) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Container */.u.Container, {
        trigger: function(open) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                onClick: open,
                "aria-label": "Click to donate reward ".concat(rewardName),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                    accessor: "rewards.donate_reward_button"
                })
            });
        },
        children: function(toggle) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialCausesModal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, donation), {
                toggle: toggle,
                onSubmit: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(socialCause) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        donateToSocialCause({
                                            socialCause: socialCause,
                                            donation: donation
                                        })
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _state.sent()
                                    ];
                            }
                        });
                    });
                    return function(socialCause) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                isLoading: isLoading
            }));
        }
    });
}
var Button = (0,stitches/* styled */.zo)(reward_styles/* StyledLinkButton */.UN, {
    alignSelf: "center",
    width: "100%"
});

// EXTERNAL MODULE: ../../node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(63602);
// EXTERNAL MODULE: ../../node_modules/yup/es/index.js + 26 modules
var yup_es = __webpack_require__(65413);
// EXTERNAL MODULE: ./src/components/ui/box/index.tsx
var box = __webpack_require__(42538);
// EXTERNAL MODULE: ./src/components/ui/stack/index.tsx
var stack = __webpack_require__(96301);
// EXTERNAL MODULE: ./src/components/uielements/formik/index.tsx + 3 modules
var formik = __webpack_require__(83269);
// EXTERNAL MODULE: ./src/utils/basket.ts
var basket = __webpack_require__(1227);
;// CONCATENATED MODULE: ./src/components/account/rewards/back-currency-modal/banked-currency-modal.tsx











function BankedCurrencyModal(param) {
    var initialAmount = param.initialAmount, rewardActionType = param.rewardActionType, onSubmit = param.onSubmit, isLoading = param.isLoading;
    var amount = (0,basket/* toDollars */.DV)(initialAmount);
    var rewardAction = rewardActionType === "redeem" ? "Redemption" : "Donation";
    var amountSchema = (0,yup_es/* object */.Ry)({
        amount: (0,yup_es/* number */.Rx)().required().max(Number(amount), "Please enter an amount up to $".concat((0,basket/* toDollars */.DV)(initialAmount))).min(0, "".concat(rewardAction, " amount must be more than $0"))
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Title */.u.Title, {
                children: "".concat((0,stringHelpers/* capitalizeFirstLetter */.fm)(rewardActionType), " Your Reward")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(stack/* Stack */.K, {
                align: "center",
                direction: "vertical",
                gap: "$4",
                css: {
                    minHeight: "100%",
                    textAlign: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                        validateOnBlur: true,
                        validateOnChange: true,
                        initialValues: {
                            amount: (0,basket/* toDollars */.DV)(initialAmount)
                        },
                        onSubmit: function(param, param1) {
                            var amount = param.amount, resetForm = param1.resetForm;
                            // Convert amount to cents
                            onSubmit(Number(amount) * 100);
                            resetForm();
                        },
                        validationSchema: amountSchema,
                        children: function(param) {
                            var isValid = param.isValid;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(banked_currency_modal_Description, {
                                                children: "You have $".concat((0,basket/* toDollars */.DV)(initialAmount), " available to ").concat(rewardActionType, ".")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(box/* Box */.x, {
                                                css: {
                                                    display: "flex",
                                                    alignItems: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        style: {
                                                            position: "relative",
                                                            left: "1rem",
                                                            fontStyle: "normal"
                                                        },
                                                        children: "$"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik/* Input */.I, {
                                                        style: {
                                                            paddingLeft: "1.125rem"
                                                        },
                                                        placeholder: "0.00",
                                                        pattern: "[0-9.]*",
                                                        type: "number",
                                                        step: "0.01",
                                                        autoFocus: true,
                                                        id: "amount",
                                                        name: "amount",
                                                        min: "0",
                                                        label: "Enter amount of rewards available to ".concat(rewardActionType)
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Footer */.u.Footer, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Cancel */.u.Cancel, {
                                                children: "Close"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledPrimaryButton */.D, {
                                                disabled: !isValid || isLoading,
                                                buttonTheme: "secondary",
                                                type: "submit",
                                                children: (0,stringHelpers/* capitalizeFirstLetter */.fm)(rewardActionType)
                                            })
                                        ]
                                    })
                                ]
                            });
                        }
                    })
                })
            })
        ]
    });
}
var banked_currency_modal_Description = (0,stitches/* styled */.zo)("p", {
    fontSize: "1rem",
    margin: 0
});
var Content = (0,stitches/* styled */.zo)(modal/* Modal.Content */.u.Content, {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    position: "relative",
    overflowY: "auto"
});

// EXTERNAL MODULE: ../../node_modules/lodash/difference.js
var difference = __webpack_require__(17335);
var difference_default = /*#__PURE__*/__webpack_require__.n(difference);
// EXTERNAL MODULE: ./src/redux/me/reducer.ts
var me_reducer = __webpack_require__(17426);
;// CONCATENATED MODULE: ./src/components/account/rewards/redeem-in-store-modal/hooks.tsx



var useBankCurrencyRedemption = function() {
    var ref = (0,redux/* useSelector */.v9)(me_reducer/* meSliceSelector */.G), myOffers = ref.myOffers, redemptions = ref.redemptions;
    var redemptionIdsAttachedToOffers = myOffers.map(function(offer) {
        var ref;
        return (ref = offer.redemption) === null || ref === void 0 ? void 0 : ref.id;
    }).filter(function(id) {
        return id !== undefined;
    });
    var allRedemptionsIds = redemptions.map(function(redemption) {
        return redemption === null || redemption === void 0 ? void 0 : redemption.id;
    });
    var bankedCurrencyRedemptionIds = difference_default()(allRedemptionsIds, redemptionIdsAttachedToOffers);
    var bankedCurrencyRedemption = redemptions.find(function(redemption) {
        return redemption.id === bankedCurrencyRedemptionIds[0];
    });
    return bankedCurrencyRedemption;
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/qrcode.react/lib/esm/index.js
var esm = __webpack_require__(29782);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/uielements/stack/stack.tsx + 2 modules
var stack_stack = __webpack_require__(45866);
// EXTERNAL MODULE: ./src/utils/loyalty.ts
var loyalty = __webpack_require__(53174);
;// CONCATENATED MODULE: ./src/components/account/rewards/scan-code/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  padding-block-start: var(--size-2);\n  opacity: 0.75;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 0.675rem;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}











var ScanCode = function(param) {
    var id = param.id, type = param.type, memberCode = param.memberCode, memberId = param.memberId, _onError = param.onError, onError = _onError === void 0 ? undefined : _onError;
    var ref = (0,redux/* useSelector */.v9)(me_reducer/* meSliceSelector */.G), activeRedemption = ref.activeRedemption, loading = ref.loading, error = ref.error;
    var organization = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.organization;
    }).organization;
    var dispatch = (0,redux/* useDispatch */.I0)();
    var QRCodeValue = activeRedemption ? activeRedemption.tracking_code : memberCode;
    var label = memberCode ? "Member Code" : activeRedemption === null || activeRedemption === void 0 ? void 0 : activeRedemption.label;
    (0,react.useEffect)(function() {
        if (id && type) {
            dispatch(actions/* default.createRedemption */.Z.createRedemption(id, type));
        }
    }, []);
    (0,react.useEffect)(function() {
        // @ts-ignore
        error && onError();
    }, [
        error
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Title */.u.Title, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                    accessor: memberCode ? "rewards.earn_in_store_modal_header" : "rewards.redeem_in_store_modal_header",
                    html: true,
                    dataObj: {
                        brand: organization.label
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Content */.u.Content, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stack_stack/* Stack */.K, {
                    align: "center",
                    direction: "vertical",
                    gap: "var(--size-4)",
                    overrides: {
                        minHeight: "100%",
                        textAlign: "center"
                    },
                    children: loading && id && type ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {
                        children: "loading..."
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    label && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                        children: label
                                    }),
                                    (activeRedemption === null || activeRedemption === void 0 ? void 0 : activeRedemption.expiring_at) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Expires, {
                                        children: [
                                            "Expires: ",
                                            (0,loyalty/* dateFormatter */.vh)(activeRedemption.expiring_at)
                                        ]
                                    })
                                ]
                            }),
                            QRCodeValue && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* QRCodeSVG */.tv, {
                                value: QRCodeValue,
                                size: 160
                            }),
                            (activeRedemption === null || activeRedemption === void 0 ? void 0 : activeRedemption.tracking_code) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    "Tracking Code: ",
                                    activeRedemption.tracking_code
                                ]
                            }),
                            memberId && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    "Member Id: ",
                                    memberId
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Disclaimer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                    accessor: memberCode ? "rewards.earn_in_store_instructional_text" : "rewards.redeem_in_store_instructional_text",
                                    html: true
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Footer */.u.Footer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Cancel */.u.Cancel, {
                    children: "Close"
                })
            })
        ]
    });
};
var Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-e23ef818-0"
})(_templateObject());
var Expires = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e23ef818-1"
})(_templateObject1());
var Disclaimer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e23ef818-2"
})(_templateObject2());
var Loading = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e23ef818-3"
})(_templateObject3());

// EXTERNAL MODULE: ./src/constants/loyalty.ts
var constants_loyalty = __webpack_require__(92106);
;// CONCATENATED MODULE: ./src/components/account/rewards/redeem-in-store-modal/redeem-in-store-modal.tsx













var RedeemInStoreModal = function(param) {
    var onClose = param.onClose, initialAmount = param.initialAmount;
    var dispatch = (0,es.useDispatch)();
    var ref = (0,es.useSelector)(me_reducer/* meSliceSelector */.G), meData = ref.data, activeRedemption = ref.activeRedemption;
    var ref1 = (0,useMutation/* useMutation */.D)({
        mutationFn: function(param) {
            var amount = param.amount, client = param.client;
            return (0,v4/* createRedemptionUsingBankCurrency */.HB)(amount, client);
        },
        onError: function(error) {
            dispatch(actions/* default.createRedemptionFailure */.Z.createRedemptionFailure(error, constants_loyalty/* REWARD_TYPE.REWARD */.Hx.REWARD));
        },
        onSuccess: function(newRedemption) {
            dispatch(actions/* default.createRedemptionSuccess */.Z.createRedemptionSuccess(newRedemption.data, constants_loyalty/* REWARD_TYPE.REWARD */.Hx.REWARD));
        }
    }), isLoading = ref1.isLoading, isSuccess = ref1.isSuccess, createRedemption = ref1.mutate;
    var bankedCurrencyRedemption = useBankCurrencyRedemption();
    (0,react.useEffect)(function() {
        if (bankedCurrencyRedemption && !activeRedemption) {
            dispatch(actions/* default.createRedemptionSuccess */.Z.createRedemptionSuccess(bankedCurrencyRedemption, constants_loyalty/* REWARD_TYPE.REWARD */.Hx.REWARD));
        }
    }, [
        bankedCurrencyRedemption,
        activeRedemption
    ]);
    (0,react.useEffect)(function() {
        return function() {
            dispatch(actions/* default.clearActiveRedemption */.Z.clearActiveRedemption());
        };
    }, []);
    return isSuccess || activeRedemption ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ScanCode, {
        type: constants_loyalty/* REWARD_TYPE.REWARD */.Hx.REWARD,
        memberId: meData === null || meData === void 0 ? void 0 : meData.external_user_fk,
        onError: onClose
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(BankedCurrencyModal, {
        onSubmit: function(amount) {
            return(// createRedemption is mutate(...)
            createRedemption({
                amount: amount,
                client: {
                    client: (0,services_client/* createHttpClient */.d9)({
                        // we should always be in a window when dealing with user sessions
                        origin: (0,src_utils/* getOrigin */.P$)(window.location.host)
                    })
                }
            }));
        },
        initialAmount: initialAmount,
        rewardActionType: "redeem",
        isLoading: isLoading
    });
};

// EXTERNAL MODULE: ./src/constants/events.ts
var constants_events = __webpack_require__(26654);
// EXTERNAL MODULE: ./src/utils/koalaAnalytics.ts + 1 modules
var koalaAnalytics = __webpack_require__(61216);
;// CONCATENATED MODULE: ./src/components/account/rewards/banked-currency/index.tsx
















var BankedCurrency = function() {
    var loyaltyState = (0,es.useSelector)(me_reducer/* meSliceSelector */.G).loyaltyState;
    var organization = (0,es.useSelector)(organization_reducer/* organizationSliceSelector */.F5);
    var bankedCurrency = loyaltyState === null || loyaltyState === void 0 ? void 0 : loyaltyState.banked_currency;
    var expirationDate = loyaltyState === null || loyaltyState === void 0 ? void 0 : loyaltyState.banked_currency_expiration_date;
    var currencyExpiring = loyaltyState === null || loyaltyState === void 0 ? void 0 : loyaltyState.banked_currency_expiring;
    // Punchh program types
    var programType = organization === null || organization === void 0 ? void 0 : organization.loyalty.program_type;
    // Only render component if 'Currency' reward program
    if (programType !== constants_loyalty/* PROGRAM_TYPES.POINTS_CONVERT_CURRENCY */.cI.POINTS_CONVERT_CURRENCY) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(reward_styles/* StyledRewardsHeaderContainer */.EE, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                        tag: reward_styles/* StyledRewardsHeader */.Nc,
                        accessor: "rewards.banked_currency_header",
                        html: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                        tag: "p",
                        accessor: "rewards.banked_currency_subheader",
                        html: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(reward_styles/* StyledBorderBottom */.Ot, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(reward_styles/* StyledBankedCash */.hb, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(reward_styles/* StyledBankedCashContent */.cs, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                tag: "h3",
                                accessor: "rewards.banked_currency_card_header",
                                html: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                children: [
                                    "$",
                                    (0,basket/* toDollars */.DV)(bankedCurrency)
                                ]
                            }),
                            !bankedCurrency ? /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                tag: "p",
                                accessor: "rewards.banked_currency_empty_state_text",
                                html: true
                            }) : // else if there is banked currency, expiration date, AND currency expiring, display the expiration date
                            expirationDate && currencyExpiring && currencyExpiring > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                tag: "p",
                                accessor: "rewards.banked_currency_expiration_text",
                                html: true,
                                dataObj: {
                                    currency: "$".concat((0,basket/* toDollars */.DV)(currencyExpiring)),
                                    date: (0,loyalty/* dateFormatter */.vh)(expirationDate)
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(reward_styles/* StyledCashButtonContainer */.Z1, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderNowCTA, {
                                label: "Rewards - Rewards"
                            }),
                            !!bankedCurrency && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Container */.u.Container, {
                                    trigger: function(open) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledPrimaryButton */.D, {
                                            onClick: function() {
                                                open();
                                                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.QR_MEMBERSHIP_VIEW */.AH.QR_MEMBERSHIP_VIEW, {
                                                    name: "Banked Currency"
                                                });
                                            },
                                            buttonTheme: "knockout",
                                            "aria-label": "Redeem banked currency in store",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                                accessor: "rewards.redeem_in_store_button"
                                            })
                                        });
                                    },
                                    children: function(toggle) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RedeemInStoreModal, {
                                            onClose: toggle,
                                            initialAmount: bankedCurrency
                                        });
                                    }
                                })
                            })
                        ]
                    }),
                    !!bankedCurrency ? /*#__PURE__*/ (0,jsx_runtime.jsx)(reward_styles/* StyledButtonContainer */.qt, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DonateToSocialCause, {
                            donation: {
                                type: "currency",
                                item: bankedCurrency.toString()
                            },
                            rewardName: "Banked Currency"
                        })
                    }) : null
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 3 modules
var polished_esm = __webpack_require__(8782);
// EXTERNAL MODULE: ./src/components/account/rewards/terms/index.tsx
var terms = __webpack_require__(43038);
;// CONCATENATED MODULE: ./src/components/account/rewards/how-rewards-work/index.tsx









var HowRewardsWork = function(param) {
    var externalURL = param.externalURL;
    var organization = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.organization;
    }).organization;
    var label = /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
        accessor: "rewards.learn_more_button"
    });
    var ariaLabel = "Click to learn how rewards work";
    // Fire KA Event
    var fireAnalyticsEvent = function() {
        return (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.GENERIC__CTA */.x.GENERIC__CTA, {
            name: constants/* EventNames.HOW_REWARDS_WORK */.V.HOW_REWARDS_WORK,
            details: "Rewards"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(reward_styles/* StyledRewardsFooterBox */.kx, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                tag: reward_styles/* StyledRewardsButtonHeader */.$G,
                accessor: "rewards.learn_more_header",
                html: true,
                dataObj: {
                    brand: organization.label
                }
            }),
            externalURL ? /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledPrimaryButton */.D, {
                "aria-label": ariaLabel,
                as: "a",
                href: externalURL,
                target: "_blank",
                onClick: function() {
                    return fireAnalyticsEvent();
                },
                children: label
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Container */.u.Container, {
                trigger: function(open) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledPrimaryButton */.D, {
                        "aria-label": ariaLabel,
                        onClick: function() {
                            open();
                            fireAnalyticsEvent();
                        },
                        children: label
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(terms/* Terms */.F, {})
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/account/rewards/mobile-qr-code/styles.tsx

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  @media (max-width: 767px) {\n    width: 64px;\n    height: 100px;\n    border-radius: 32px;\n    box-shadow: 0 0 8px 0 #ccc;\n    border: none;\n    background: ",
        ";\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n\n    p {\n      position: absolute;\n      bottom: 0;\n      font-family: ",
        ";\n      font-size: 16px;\n      color: ",
        ";\n    }\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 48px;\n  height: 48px;\n  border-radius: 24px;\n  background: ",
        ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 7px;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  bottom: var(--safe-offset--descending, 0);\n  margin-bottom: var(--size-4);\n  right: var(--size-4);\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var _background_color;
var StyledMobileQRCodeButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-49725be0-0"
})(styles_templateObject(), function(param) {
    var theme = param.theme;
    return theme.auth_page.background_color;
}, function(param) {
    var theme = param.theme;
    return theme.primary_font.bold.font_family;
}, function(param) {
    var theme = param.theme;
    return (0,polished_esm/* getContrast */.mj)((_background_color = theme.auth_page.background_color) !== null && _background_color !== void 0 ? _background_color : "#fff", theme.global.primary_active_color) > 4.5 ? theme.global.primary_active_color : theme.auth_page.font.color;
});
var StyledQRCodeIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-49725be0-1"
})(styles_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.global.primary_active_color;
});
var StyledQRCodeContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-49725be0-2"
})(styles_templateObject2());

;// CONCATENATED MODULE: ./src/components/account/rewards/mobile-qr-code/index.tsx








var MobileQRCode = function() {
    var ref = (0,es.useSelector)(me_reducer/* meSliceSelector */.G), me = ref.data;
    if (!(me === null || me === void 0 ? void 0 : me.qrcode)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledQRCodeContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Container */.u.Container, {
                trigger: function(open) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMobileQRCodeButton, {
                        "aria-label": "Click to view your membership ID",
                        onClick: function() {
                            open();
                            (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.QR_MEMBERSHIP_VIEW */.AH.QR_MEMBERSHIP_VIEW, {
                                name: "Mobile Scan Button"
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledQRCodeIcon, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/static/img/icons/qr.svg",
                                    alt: "Scan QR Code Icon",
                                    role: "presentation"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Scan"
                            })
                        ]
                    });
                },
                children: function() {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ScanCode, {
                        memberCode: me.qrcode,
                        memberId: me === null || me === void 0 ? void 0 : me.external_user_fk
                    });
                }
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/account/rewards/points-history/points-history.style.ts

function points_history_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: var(--neg-size-6) 0;\n  padding: 0;\n"
    ]);
    points_history_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function points_history_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: var(--size-3) 0;\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid ",
        ";\n\n  h3 {\n    font-size: 16px;\n  }\n\n  h2 {\n    font-size: 16px;\n    ",
        "\n  }\n\n  &:last-of-type {\n    border: none;\n  }\n"
    ]);
    points_history_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function points_history_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  h3 {\n    font-size: 20px;\n    font-family: ",
        ";\n    margin: 0 auto;\n  }\n\n  button {\n    width: 100%;\n  }\n"
    ]);
    points_history_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var History = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-18ae6584-0"
})(points_history_style_templateObject());
var HistoryItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-18ae6584-1"
})(points_history_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.global.primary_border_color;
}, function(param) {
    var addition = param.addition, theme = param.theme;
    return addition && "\n    color: ".concat(theme.global.primary_active_color, ";\n  ");
});
var EmptyState = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18ae6584-2"
})(points_history_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.primary_font.bold.font_family;
});

// EXTERNAL MODULE: ./src/constants/cssClassNames.ts
var cssClassNames = __webpack_require__(5733);
// EXTERNAL MODULE: ./src/constants/dates.ts
var dates = __webpack_require__(81584);
// EXTERNAL MODULE: ./src/utils/dates.ts + 59 modules
var utils_dates = __webpack_require__(63654);
;// CONCATENATED MODULE: ./src/components/account/rewards/points-history/index.tsx













var PointsHistory = function() {
    var rewardsHistory = (0,es.useSelector)(function(state) {
        return state.app.me.rewardsHistory;
    });
    var dispatch = (0,es.useDispatch)();
    var hasRewards = rewardsHistory.length > 0 ? true : false;
    (0,react.useEffect)(function() {
        dispatch(actions/* default.fetchRewardsHistory */.Z.fetchRewardsHistory());
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(reward_styles/* StyledRewardsFooterBox */.kx, {
        className: cssClassNames/* CSS_CLASSES.LOYALTY_REWARDS_FOOTER.POINTS_HISTORY */.Y.LOYALTY_REWARDS_FOOTER.POINTS_HISTORY,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                tag: reward_styles/* StyledRewardsButtonHeader */.$G,
                accessor: "rewards.point_history_header"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Container */.u.Container, {
                trigger: function(open) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledPrimaryButton */.D, {
                        onClick: open,
                        buttonTheme: "knockout",
                        "aria-label": "Click to view your points history",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                            accessor: "rewards.point_history_button"
                        })
                    });
                },
                children: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Title */.u.Title, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                    accessor: "rewards.point_history_modal_header",
                                    html: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Content */.u.Content, {
                                children: hasRewards ? /*#__PURE__*/ (0,jsx_runtime.jsx)(History, {
                                    children: rewardsHistory.map(function(item, index) {
                                        return item.value && /*#__PURE__*/ (0,jsx_runtime.jsxs)(HistoryItem, {
                                            addition: item.value.indexOf("+") > -1,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: (0,utils_dates/* formatDate */.p6)(item.date, dates/* DATE_FORMAT.MONTH_DAY_YEAR */.z.MONTH_DAY_YEAR)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    children: item.value
                                                })
                                            ]
                                        }, "".concat(item.date, "-").concat(index));
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyState, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                            tag: "h3",
                                            accessor: "rewards.points_history_modal_empty_header",
                                            html: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                            tag: "p",
                                            accessor: "rewards.points_history_modal_empty_subheader",
                                            html: true
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Footer */.u.Footer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Cancel */.u.Cancel, {
                                        children: "Close"
                                    }),
                                    !hasRewards && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderNowCTA, {
                                        label: "Rewards - History Modal"
                                    })
                                ]
                            })
                        ]
                    });
                }
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/uielements/box/box.tsx + 1 modules
var box_box = __webpack_require__(68801);
// EXTERNAL MODULE: ./src/utils/safePolished.ts
var safePolished = __webpack_require__(68902);
;// CONCATENATED MODULE: ./src/components/account/rewards/redeem-receipt/redeem-receipt.tsx


function redeem_receipt_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1rem;\n  margin: 0;\n"
    ]);
    redeem_receipt_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



















// Validation schema for the barcode submission form.
var barcodeSchema = (0,yup_es/* object */.Ry)({
    barcode: (0,yup_es/* string */.Z_)()
});
var RedeemReceipt = function() {
    var dispatch = (0,es.useDispatch)();
    var receiptBarcodeLoading = (0,es.useSelector)(me_reducer/* meSliceSelector */.G).receiptBarcodeLoading;
    var strings = (0,cmsConfig/* useStrings */.EL)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(reward_styles/* StyledRewardsFooterBox */.kx, {
        className: cssClassNames/* CSS_CLASSES.LOYALTY_REWARDS_FOOTER.RECEIPT_BARCODE */.Y.LOYALTY_REWARDS_FOOTER.RECEIPT_BARCODE,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                tag: reward_styles/* StyledRewardsButtonHeader */.$G,
                accessor: "rewards.enter_barcode_header"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Container */.u.Container, {
                trigger: function(open) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledPrimaryButton */.D, {
                        onClick: open,
                        buttonTheme: "knockout",
                        "aria-label": "Click to redeem rewards from a receipt barcode",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                            accessor: "rewards.enter_barcode_button"
                        })
                    });
                },
                children: function(toggle) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Title */.u.Title, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                    accessor: "rewards.enter_barcode_modal_header",
                                    html: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                                initialValues: {
                                    barcode: ""
                                },
                                onSubmit: function(param, param1) {
                                    var barcode = param.barcode, resetForm = param1.resetForm;
                                    dispatch(actions/* default.redeemReceiptBarcode */.Z.redeemReceiptBarcode(barcode));
                                    toggle();
                                    resetForm();
                                },
                                validationSchema: barcodeSchema,
                                children: function(param) {
                                    var dirty = param.dirty, isValid = param.isValid;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Content */.u.Content, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(redeem_receipt_Description, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                                            accessor: "rewards.enter_barcode_instructional_text",
                                                            html: true
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(box_box/* Box */.x, {
                                                        overrides: {
                                                            marginTop: "var(--size-3)"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik/* Input */.I, {
                                                            autoFocus: true,
                                                            id: "barcode",
                                                            name: "barcode",
                                                            label: (0,stringHelpers/* safelyGetString */.bc)(strings, "rewards.enter_barcode_placeholder_text")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(redeem_receipt_Disclaimer, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                                            accessor: "rewards.enter_barcode_disclaimer_text",
                                                            html: true
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Footer */.u.Footer, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Cancel */.u.Cancel, {
                                                        children: "Close"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledPrimaryButton */.D, {
                                                        disabled: !dirty || !isValid,
                                                        submitting: receiptBarcodeLoading,
                                                        buttonTheme: "secondary",
                                                        type: "submit",
                                                        children: "Submit"
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                }
                            })
                        ]
                    });
                }
            })
        ]
    });
};
var redeem_receipt_Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-a6bbeb0-0"
})(redeem_receipt_templateObject());
var redeem_receipt_Disclaimer = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-a6bbeb0-1"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread/* default */.Z)({
        fontSize: ".75rem",
        margin: 0
    }, (0,utils/* getFontStyles */.l)(theme.text.primary_font, [
        "color"
    ], {
        color: function(value) {
            return value ? (0,safePolished/* safePolished */.F)(polished_esm/* transparentize */.DZ)("0.1", value) : "inherit";
        }
    }));
});

// EXTERNAL MODULE: ./src/brand-components/index.ts + 14 modules
var brand_components = __webpack_require__(96588);
;// CONCATENATED MODULE: ./src/components/account/rewards/footer/index.tsx

function footer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: ",
        ";\n\n  justify-content: center;\n  min-width: 100%;\n  padding: var(--size-5) var(--size-5) var(--size-32); // Large bottom padding account for mobile QR code\n  width: 100%;\n\n  h1 {\n    font-family: ",
        ";\n    font-size: 24px;\n    text-align: left;\n  }\n\n  button {\n    align-items: center;\n    max-width: 75%;\n\n    @media (max-width: 1024px) {\n      min-width: 100% !important;\n    }\n  }\n\n  @media (min-width: 768px) {\n    padding: var(--size-16) var(--size-5);\n  }\n"
    ]);
    footer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function footer_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  gap: var(--size-12);\n  grid-template-columns: 1fr;\n  margin: 0 auto;\n  max-width: var(--size-4xl);\n  width: 100%;\n\n  @media (min-width: 768px) {\n    gap: var(--size-5);\n    grid-template-columns: repeat(3, 1fr);\n  }\n"
    ]);
    footer_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












function RewardsFooter() {
    var slug = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.organization.organization;
    }).slug;
    var ref = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.cmsConfig;
    }), webConfig = ref.webConfig, strings = ref.strings;
    var howRewardsWorkExternalURL = strings.rewards.learn_more_url;
    var REWARDS_TERMS_CONTENT = brand_components/* COMPONENT_CONFIG.MODAL_HOW_REWARDS_WORK */.P.MODAL_HOW_REWARDS_WORK[slug];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(footer_Content, {
                    children: [
                        (howRewardsWorkExternalURL || REWARDS_TERMS_CONTENT) && /*#__PURE__*/ (0,jsx_runtime.jsx)(HowRewardsWork, {
                            externalURL: howRewardsWorkExternalURL
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(loyaltyAccessor/* default */.Z, {
                            checkType: constants_loyalty/* LOYALTY_ACCESSOR_TYPES.FEATURE */.Mo.FEATURE,
                            checkName: constants_loyalty/* LOYALTY_FEATURES.SHOW_LOYALTY_HISTORY */.lw.SHOW_LOYALTY_HISTORY,
                            component: /*#__PURE__*/ (0,jsx_runtime.jsx)(PointsHistory, {})
                        }),
                        webConfig.accounts.barcode_scan && /*#__PURE__*/ (0,jsx_runtime.jsx)(loyaltyAccessor/* default */.Z, {
                            checkType: constants_loyalty/* LOYALTY_ACCESSOR_TYPES.FEATURE */.Mo.FEATURE,
                            checkName: constants_loyalty/* LOYALTY_FEATURES.CLAIM_REWARDS_BY_RECEIPT */.lw.CLAIM_REWARDS_BY_RECEIPT,
                            component: /*#__PURE__*/ (0,jsx_runtime.jsx)(RedeemReceipt, {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(loyaltyAccessor/* default */.Z, {
                checkType: constants_loyalty/* LOYALTY_ACCESSOR_TYPES.FEATURE */.Mo.FEATURE,
                checkName: constants_loyalty/* LOYALTY_FEATURES.SUPPORTS_QR */.lw.SUPPORTS_QR,
                component: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileQRCode, {})
            })
        ]
    });
}
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-176a792-0"
})(footer_templateObject(), function(param) {
    var theme = param.theme;
    return (0,safePolished/* safePolished */.F)(polished_esm/* transparentize */.DZ)("0.9", theme.global.primary_active_color);
}, function(param) {
    var theme = param.theme;
    return theme.primary_font.bold.font_family;
});
var footer_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-176a792-1"
})(footer_templateObject1());

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(64297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(58408);
// EXTERNAL MODULE: ../../packages/sdk/dist/index.mjs + 1 modules
var dist = __webpack_require__(80684);
// EXTERNAL MODULE: ./src/components/account/accountInformation/styles.ts
var accountInformation_styles = __webpack_require__(41059);
// EXTERNAL MODULE: ./src/constants/styles.ts
var constants_styles = __webpack_require__(30438);
;// CONCATENATED MODULE: ./src/components/account/rewards/loyaltyState/styles.ts

function loyaltyState_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: ",
        ";\n  display: flex;\n  height: 400px;\n  justify-content: center;\n  padding: ",
        "px;\n  text-align: center;\n  width: 100%;\n\n  > div {\n    width: 100%;\n  }\n\n  h2,\n  h3 {\n    font-size: 20px;\n    margin: 0 0 ",
        "px;\n\n    @media (max-width: 767px) {\n      font-size: 16px;\n      margin-bottom: ",
        "px;\n    }\n  }\n\n  h3 {\n    font-family: ",
        ";\n    font-weight: normal;\n  }\n\n  @media (max-width: 767px) {\n    height: auto;\n    margin-top: ",
        "px;\n    padding: ",
        "px ",
        "px;\n  }\n"
    ]);
    loyaltyState_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function loyaltyState_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        "px;\n  font-family: ",
        ";\n  margin: 0 0 ",
        "px;\n\n  @media (max-width: 767px) {\n    font-size: ",
        "px;\n    margin-bottom: ",
        "px;\n  }\n"
    ]);
    loyaltyState_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function loyaltyState_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin: 0 0 ",
        "px;\n  justify-content: center;\n\n  .wrapper {\n    max-width: 500px;\n    width: 100%;\n  }\n\n  .progress-bar {\n    width: 100%;\n    background: ",
        ";\n    border-radius: 12px;\n    border: 1px solid ",
        ";\n    overflow: hidden;\n  }\n\n  .progress-bar-fill {\n    display: block;\n    height: 24px;\n    transition: width 500ms ease-in-out;\n    background: ",
        ";\n    border-radius: 12px;\n  }\n\n  @media (max-width: 767px) {\n    margin: 0 0 ",
        "px;\n  }\n"
    ]);
    loyaltyState_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  margin: ",
        "px;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var StyledLoyaltyStateContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ac40e261-0"
})(loyaltyState_styles_templateObject(), function(param) {
    var theme = param.theme;
    return theme.global.secondary_body_color;
}, constants_styles/* LAYOUT.GUTTER */._.GUTTER, constants_styles/* LAYOUT.GUTTER */._.GUTTER, constants_styles/* LAYOUT.GUTTER */._.GUTTER / 2, function(param) {
    var theme = param.theme;
    return theme.primary_font.regular.font_family;
}, constants_styles/* LAYOUT.LOYALTY_MENU_HEIGHT_MOBILE */._.LOYALTY_MENU_HEIGHT_MOBILE, constants_styles/* LAYOUT.GUTTER */._.GUTTER * 2, constants_styles/* LAYOUT.GUTTER */._.GUTTER);
var StyledPointsHeader = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-ac40e261-1"
})(loyaltyState_styles_templateObject1(), function(props) {
    return props.currentPoints > 0 ? 48 : 32;
}, function(param) {
    var theme = param.theme;
    return theme.primary_font.bold.font_family;
}, constants_styles/* LAYOUT.GUTTER */._.GUTTER, function(props) {
    return props.currentPoints > 0 ? 38 : 28;
}, constants_styles/* LAYOUT.GUTTER */._.GUTTER / 2);
var StyledProgressBarHorizontal = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ac40e261-2"
})(loyaltyState_styles_templateObject2(), constants_styles/* LAYOUT.GUTTER */._.GUTTER, function(param) {
    var theme = param.theme;
    return (0,safePolished/* safePolished */.F)(polished_esm/* transparentize */.DZ)(".9", theme.global.primary_border_color);
}, function(param) {
    var theme = param.theme;
    return theme.global.primary_border_color;
}, function(param) {
    var theme = param.theme;
    return theme.global.primary_active_color;
}, constants_styles/* LAYOUT.GUTTER */._.GUTTER);
var StyledFlexContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ac40e261-3"
})(styles_templateObject3(), constants_styles/* LAYOUT.GUTTER */._.GUTTER);

;// CONCATENATED MODULE: ./src/components/account/rewards/loyaltyState/index.tsx














var LoyaltyState = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(LoyaltyState, Component);
    var _super = (0,_create_super/* default */.Z)(LoyaltyState);
    function LoyaltyState() {
        (0,_class_call_check/* default */.Z)(this, LoyaltyState);
        var _this;
        _this = _super.apply(this, arguments);
        _this.renderPointsHeader = function(currentPoints, pointsUntilNextReward, nextPointTier) {
            var pointsCounter = (0,stringHelpers/* pluralizeString */.fB)((0,stringHelpers/* safelyGetString */.bc)(_this.props.strings, "rewards.rewards_counter"), nextPointTier > 1);
            // User has no points
            if (!currentPoints) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                    accessor: "rewards.no_rewards_header",
                    html: true
                });
            }
            // User has reached max tier
            if (!pointsUntilNextReward) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                        accessor: "rewards.maximum_tier_header",
                        html: true,
                        dataObj: {
                            points: currentPoints.toLocaleString()
                        }
                    })
                });
            }
            return(// All other cases
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    currentPoints.toLocaleString(),
                    "/",
                    nextPointTier.toLocaleString(),
                    " ",
                    pointsCounter
                ]
            }));
        };
        return _this;
    }
    var _proto = LoyaltyState.prototype;
    _proto.render = function render() {
        var _props = this.props, loyaltyState = _props.loyaltyState, organization = _props.organization, myRedeemables = _props.myRedeemables, strings = _props.strings;
        var membershipLevelName = loyaltyState === null || loyaltyState === void 0 ? void 0 : loyaltyState.membership_level_name;
        var ref;
        var currentPoints = (ref = loyaltyState === null || loyaltyState === void 0 ? void 0 : loyaltyState.points) !== null && ref !== void 0 ? ref : 0;
        var programType = organization === null || organization === void 0 ? void 0 : organization.loyalty.program_type;
        // Find the next largest reward after the one we can afford
        var nextPointTier = dist/* sdkUtils.nextLargestRewardPointValue */.fH.nextLargestRewardPointValue(programType, // @ts-expect-error ensure that `loyaltyState` is defined.
        loyaltyState, myRedeemables);
        var progressBarWidth = dist/* sdkUtils.calculateProgressBarWidth */.fH.calculateProgressBarWidth(currentPoints, nextPointTier);
        var pointsUntilNextReward = nextPointTier - currentPoints > 0 ? nextPointTier - currentPoints : 0;
        var pointsCounter = (0,stringHelpers/* pluralizeString */.fB)((0,stringHelpers/* safelyGetString */.bc)(strings, "rewards.rewards_counter"), pointsUntilNextReward !== 1);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLoyaltyStateContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPointsHeader, {
                        currentPoints: currentPoints,
                        children: this.renderPointsHeader(currentPoints, pointsUntilNextReward, nextPointTier)
                    }),
                    pointsUntilNextReward > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProgressBarHorizontal, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "progress-bar",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "progress-bar-fill",
                                    style: {
                                        width: progressBarWidth
                                    }
                                })
                            })
                        })
                    }),
                    pointsUntilNextReward > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                    accessor: "rewards.points_meter_subheader",
                                    html: true,
                                    dataObj: {
                                        number: pointsUntilNextReward.toLocaleString(),
                                        counter: pointsCounter,
                                        conversionRate: programType === constants_loyalty/* PROGRAM_TYPES.POINTS_CONVERT_CURRENCY */.cI.POINTS_CONVERT_CURRENCY && "$".concat(loyaltyState === null || loyaltyState === void 0 ? void 0 : loyaltyState.conversion_rate)
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                tag: "h3",
                                accessor: "rewards.user_summary_total_available_points_text",
                                html: true,
                                dataObj: {
                                    points: currentPoints.toString()
                                }
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                        tag: "h2",
                        accessor: "rewards.maximum_tier_subheader",
                        html: true
                    }),
                    !pointsUntilNextReward && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFlexContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(accountInformation_styles/* StyledButtonContainer */.qt, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderNowCTA, {
                                label: "Rewards - Loyalty State"
                            })
                        })
                    }),
                    membershipLevelName && /*#__PURE__*/ (0,jsx_runtime.jsxs)(reward_styles/* StyledMembershipLevelTag */.LS, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/static/img/icons/trophy.svg",
                                alt: "Trophy Icon"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                accessor: "rewards.user_summary_membership_level_text",
                                html: true,
                                dataObj: {
                                    level: membershipLevelName
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                        accessor: "rewards.pending_points_disclaimer",
                        html: true,
                        tag: reward_styles/* StyledRewardDisclaimer */.jp
                    })
                ]
            })
        });
    };
    return LoyaltyState;
}(react.Component);
var mapStateToProps = function(state) {
    return {
        loyaltyState: state.app.me.loyaltyState,
        myRedeemables: state.app.me.redeemables,
        organization: state.app.organization,
        strings: state.app.cmsConfig.strings
    };
};
var connector = (0,es.connect)(mapStateToProps);
/* harmony default export */ var rewards_loyaltyState = (connector(LoyaltyState));

// EXTERNAL MODULE: ./src/components/account/uielements/index.tsx + 1 modules
var uielements = __webpack_require__(9671);
;// CONCATENATED MODULE: ./src/components/account/rewards/my-offers/index.tsx

















var MyOffers = function() {
    var myOffers = (0,es.useSelector)(me_reducer/* meSliceSelector */.G).myOffers;
    var organization = (0,es.useSelector)(organization_reducer/* organizationSliceSelector */.F5);
    var dispatch = (0,es.useDispatch)();
    // Program types
    var programType = organization === null || organization === void 0 ? void 0 : organization.loyalty.program_type;
    var programsWithRewardsHeader = [
        constants_loyalty/* PROGRAM_TYPES.POINTS_CONVERT_REWARDS */.cI.POINTS_CONVERT_REWARDS,
        constants_loyalty/* PROGRAM_TYPES.SP_POINTS_CONVERT_REWARDS */.cI.SP_POINTS_CONVERT_REWARDS, 
    ];
    // For `points_convert_rewards` &`sp_points_convert_rewards` types, we rename the 'Offers' section 'Rewards'
    var header = /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
        accessor: programsWithRewardsHeader.includes(programType) ? "rewards.my_rewards_header" : "rewards.offers_header",
        html: true
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(reward_styles/* StyledRewardsHeaderContainer */.EE, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(reward_styles/* StyledRewardsHeader */.Nc, {
                        children: [
                            header,
                            " (",
                            myOffers.length,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(reward_styles/* StyledBorderBottom */.Ot, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(reward_styles/* StyledRewardsFlexContainer */.xc, {
                children: myOffers.length > 0 ? myOffers.map(function(offer, index) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(reward_styles/* StyledReward */.i$, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(reward_styles/* StyledRewardTopContent */.r7, {
                                children: [
                                    ((ref = offer.image) === null || ref === void 0 ? void 0 : ref.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: offer.image.url,
                                        alt: offer.label
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: offer.label
                                            }),
                                            offer.expires_at && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "Expires: ",
                                                    (0,loyalty/* dateFormatter */.vh)(offer.expires_at)
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: offer.description && offer.description.split("\n").map(function(line, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(reward_styles/* StyledRewardDescription */.Fl, {
                                        children: line.trim()
                                    }, "line-".concat(i));
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(reward_styles/* StyledCashButtonContainer */.Z1, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderNowCTA, {
                                        label: "Rewards - Offers"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(loyaltyAccessor/* default */.Z, {
                                        checkType: constants_loyalty/* LOYALTY_ACCESSOR_TYPES.FEATURE */.Mo.FEATURE,
                                        checkName: constants_loyalty/* LOYALTY_FEATURES.CREATE_REDEMPTION_USING_REWARD */.lw.CREATE_REDEMPTION_USING_REWARD,
                                        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Container */.u.Container, {
                                            onCancel: function() {
                                                return dispatch(actions/* default.clearActiveRedemption */.Z.clearActiveRedemption());
                                            },
                                            trigger: function(open) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledPrimaryButton */.D, {
                                                    buttonTheme: "knockout",
                                                    "aria-label": "Click to redeem reward ".concat(offer.label, " in store"),
                                                    onClick: open,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                                        accessor: "rewards.redeem_in_store_button"
                                                    })
                                                });
                                            },
                                            children: function(toggle) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScanCode, {
                                                    id: offer.id,
                                                    type: constants_loyalty/* REWARD_TYPE.OFFER */.Hx.OFFER,
                                                    onError: toggle
                                                });
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                                condition: offer.supports_donation,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(reward_styles/* StyledButtonContainer */.qt, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DonateToSocialCause, {
                                        donation: {
                                            type: "reward",
                                            item: offer.id
                                        },
                                        rewardName: offer.label
                                    })
                                })
                            })
                        ]
                    }, index);
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(reward_styles/* StyledNoOffers */.RX, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements/* ConnectedRewardsIcon */.Cu, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                            tag: "h3",
                            accessor: "rewards.no_offers_header",
                            html: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                            tag: "p",
                            accessor: "rewards.no_offers_subheader",
                            html: true
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/account/rewards/my-rewards/index.tsx


















var MyRewards = function() {
    var ref = (0,es.useSelector)(me_reducer/* meSliceSelector */.G), redeemables = ref.redeemables, loyaltyState = ref.loyaltyState;
    var strings = (0,cmsConfig/* useStrings */.EL)();
    var organization = (0,es.useSelector)(organization_reducer/* organizationSliceSelector */.F5);
    var dispatch = (0,es.useDispatch)();
    var currentPoints = loyaltyState === null || loyaltyState === void 0 ? void 0 : loyaltyState.points;
    // Only count rewards that user has enough points for
    var myActiveRedeemables = (0,loyalty/* getActiveRewardsAndOffersLength */.gx)(redeemables, [], /** @TODO ensure that `currentPoints` is defined. */ // @ts-expect-error
    currentPoints);
    // Punchh program types
    var programType = organization === null || organization === void 0 ? void 0 : organization.loyalty.program_type;
    // Only render if 'Redeemables' reward program
    if (programType !== constants_loyalty/* PROGRAM_TYPES.POINTS_CONVERT_REDEEMABLES */.cI.POINTS_CONVERT_REDEEMABLES) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            redeemables && /*#__PURE__*/ (0,jsx_runtime.jsxs)(reward_styles/* StyledRewardsHeaderContainer */.EE, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(reward_styles/* StyledRewardsHeader */.Nc, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                accessor: "rewards.my_rewards_header",
                                html: true
                            }),
                            "\xa0(",
                            myActiveRedeemables,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                        tag: "p",
                        accessor: "rewards.my_rewards_subheader",
                        html: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(reward_styles/* StyledBorderBottom */.Ot, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(reward_styles/* StyledRewardsFlexContainer */.xc, {
                children: redeemables.map(function(reward) {
                    var ref;
                    var rewardNotRedeemable = /** @TODO ensure that `points` is defined. */ // @ts-expect-error
                    reward.points_required > (loyaltyState === null || loyaltyState === void 0 ? void 0 : loyaltyState.points);
                    var pointsCounter = (0,stringHelpers/* pluralizeString */.fB)((0,stringHelpers/* safelyGetString */.bc)(strings, "rewards.rewards_counter"), reward.points_required > 1);
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(reward_styles/* StyledReward */.i$, {
                        inactive: rewardNotRedeemable,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(reward_styles/* StyledRewardTopContent */.r7, {
                                children: [
                                    ((ref = reward.image) === null || ref === void 0 ? void 0 : ref.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(reward_styles/* StyledRewardImage */.ID, {
                                        inactive: rewardNotRedeemable,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: reward.image.url,
                                            alt: reward.label
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: reward.label
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                                children: [
                                                    reward.points_required.toLocaleString(),
                                                    " ",
                                                    pointsCounter
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: reward.description && reward.description.split("\n").map(function(line, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(reward_styles/* StyledRewardDescription */.Fl, {
                                        children: line.trim()
                                    }, "line-".concat(i));
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(reward_styles/* StyledCashButtonContainer */.Z1, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderNowCTA, {
                                        label: "Rewards - Rewards"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(loyaltyAccessor/* default */.Z, {
                                        checkType: constants_loyalty/* LOYALTY_ACCESSOR_TYPES.FEATURE */.Mo.FEATURE,
                                        checkName: constants_loyalty/* LOYALTY_FEATURES.CREATE_REDEMPTION_USING_REDEEMABLE */.lw.CREATE_REDEMPTION_USING_REDEEMABLE,
                                        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Container */.u.Container, {
                                            onCancel: function() {
                                                return dispatch(actions/* default.clearActiveRedemption */.Z.clearActiveRedemption());
                                            },
                                            trigger: function(open) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledPrimaryButton */.D, {
                                                    buttonTheme: "knockout",
                                                    "aria-label": "Click to redeem reward ".concat(reward.label, " in store"),
                                                    onClick: open,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                                        accessor: "rewards.redeem_in_store_button"
                                                    })
                                                });
                                            },
                                            children: function(toggle) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScanCode, {
                                                    id: reward.id,
                                                    type: constants_loyalty/* REWARD_TYPE.REWARD */.Hx.REWARD,
                                                    onError: toggle
                                                });
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                                condition: reward.supports_donation,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(reward_styles/* StyledButtonContainer */.qt, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DonateToSocialCause, {
                                        donation: {
                                            type: "redeemable",
                                            item: reward.id.toString()
                                        },
                                        rewardName: reward.label
                                    })
                                })
                            })
                        ]
                    }, reward.id);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/account/styles.ts
var account_styles = __webpack_require__(99736);
// EXTERNAL MODULE: ./src/components/app/layout/index.tsx + 109 modules
var layout = __webpack_require__(12373);
// EXTERNAL MODULE: ./src/components/restrict/index.tsx
var restrict = __webpack_require__(40129);
// EXTERNAL MODULE: ./src/redux/me/use-account.ts
var use_account = __webpack_require__(9455);
// EXTERNAL MODULE: ./src/utils/auth.ts + 1 modules
var auth = __webpack_require__(10606);
;// CONCATENATED MODULE: ./pages/account/rewards/index.tsx















var RewardsPage = function() {
    var ref = (0,use_account/* useAccountDispatch */.U)(), dispatch = ref.dispatch, fetchRewardsHistory = ref.fetchRewardsHistory, fetchRedeemables = ref.fetchRedeemables, fetchOffers = ref.fetchOffers, fetchLoyaltyState = ref.fetchLoyaltyState, fetchRedemptions = ref.fetchRedemptions;
    var loyaltyState = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.me.loyaltyState;
    });
    (0,react.useEffect)(function() {
        if ((0,auth/* userLoggedIn */.nD)()) {
            dispatch(fetchRewardsHistory());
            dispatch(fetchRedeemables());
            dispatch(fetchOffers());
            dispatch(fetchLoyaltyState());
            dispatch(fetchRedemptions());
        }
    }, []);
    // Don't render rewards page until we have loyaltyState
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(restrict/* RestrictedAccountRoute */.Q, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* default */.Z, {
            children: loyaltyState && /*#__PURE__*/ (0,jsx_runtime.jsxs)(account_styles/* StyledTopLevelLoyaltyContainer */.JP, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(loyaltyAccessor/* default */.Z, {
                        checkType: constants_loyalty/* LOYALTY_ACCESSOR_TYPES.FEATURE */.Mo.FEATURE,
                        checkName: constants_loyalty/* LOYALTY_FEATURES.SHOW_LOYALTY_STATE */.lw.SHOW_LOYALTY_STATE,
                        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(rewards_loyaltyState, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(account_styles/* StyledSecondarySection */.Qu, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(loyaltyAccessor/* default */.Z, {
                                checkType: constants_loyalty/* LOYALTY_ACCESSOR_TYPES.FEATURE */.Mo.FEATURE,
                                checkName: constants_loyalty/* LOYALTY_FEATURES.INDEX_REDEEMABLES */.lw.INDEX_REDEEMABLES,
                                component: /*#__PURE__*/ (0,jsx_runtime.jsx)(MyRewards, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BankedCurrency, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(loyaltyAccessor/* default */.Z, {
                                checkType: constants_loyalty/* LOYALTY_ACCESSOR_TYPES.FEATURE */.Mo.FEATURE,
                                checkName: constants_loyalty/* LOYALTY_FEATURES.INDEX_MY_REWARDS */.lw.INDEX_MY_REWARDS,
                                component: /*#__PURE__*/ (0,jsx_runtime.jsx)(MyOffers, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RewardsFooter, {})
                ]
            })
        })
    });
};
/* harmony default export */ var rewards = (RewardsPage);


/***/ }),

/***/ 43038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Terms; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _brand_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96588);
/* harmony import */ var _components_uielements_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84247);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86879);




function Terms() {
    var slug = (0,_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return state.app.organization.organization;
    }).slug;
    var REWARDS_TERMS_CONTENT = _brand_components__WEBPACK_IMPORTED_MODULE_1__/* .COMPONENT_CONFIG.MODAL_HOW_REWARDS_WORK */ .P.MODAL_HOW_REWARDS_WORK[slug];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_modal__WEBPACK_IMPORTED_MODULE_2__/* .Modal.Title */ .u.Title, {
                children: "How Rewards Work"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_modal__WEBPACK_IMPORTED_MODULE_2__/* .Modal.Content */ .u.Content, {
                children: REWARDS_TERMS_CONTENT && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(REWARDS_TERMS_CONTENT, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_modal__WEBPACK_IMPORTED_MODULE_2__/* .Modal.Footer */ .u.Footer, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_modal__WEBPACK_IMPORTED_MODULE_2__/* .Modal.Cancel */ .u.Cancel, {
                    children: "Close"
                })
            })
        ]
    });
}


/***/ }),

/***/ 99736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$3": function() { return /* binding */ StyledContactInfoContainer; },
/* harmony export */   "Dk": function() { return /* binding */ StyledInlineCancelAndSubmitButtons; },
/* harmony export */   "Gq": function() { return /* binding */ StyledForm; },
/* harmony export */   "JP": function() { return /* binding */ StyledTopLevelLoyaltyContainer; },
/* harmony export */   "Ji": function() { return /* binding */ StyledContactInfoContent; },
/* harmony export */   "Ll": function() { return /* binding */ StyledFormField; },
/* harmony export */   "Mo": function() { return /* binding */ StyledCancelEdit; },
/* harmony export */   "Pw": function() { return /* binding */ StyledFlexedHeader; },
/* harmony export */   "Qu": function() { return /* binding */ StyledSecondarySection; },
/* harmony export */   "UN": function() { return /* binding */ StyledLinkButton; },
/* harmony export */   "VX": function() { return /* binding */ StyledCancelAndSubmitButtons; },
/* harmony export */   "aN": function() { return /* binding */ StyledAccountContainer; },
/* harmony export */   "fb": function() { return /* binding */ StyledInlineFormContainer; },
/* harmony export */   "t9": function() { return /* binding */ StyledLoyaltyContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89961);
/* harmony import */ var _constants_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30438);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: var(--size-3);\n  padding-top: var(--size-3);\n\n  @media (min-width: 768px) {\n    gap: var(--size-6);\n    padding-top: var(--size-6);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0 auto;\n  max-width: ",
        "px;\n  padding: ",
        "px 0;\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: ",
        "px;\n  margin: ",
        "px auto 0;\n\n  @media (max-width: 767px) {\n    margin-top: ",
        "px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  // to ensure first component never goes behind the loyalty nav\n  margin-top: ",
        "px;\n\n  @media (max-width: 767px) {\n    margin-top: ",
        "px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  margin: 0 auto;\n  justify-content: center;\n  width: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  width: 100%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 1 1 33.333%;\n  height: ",
        ";\n  overflow: hidden;\n  position: relative;\n\n  &:not(:first-child) {\n    padding-left: ",
        "px;\n\n    @media (max-width: 767px) {\n      padding-left: 0;\n    }\n  }\n\n  @media (max-width: 767px) {\n    flex-basis: 100%;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: right;\n  align-self: flex-end;\n\n  @media (max-width: 767px) {\n    display: flex;\n    flex-direction: column-reverse;\n    width: 100%;\n    margin: 0;\n\n    button {\n      width: 100%;\n    }\n\n    > div:first-child {\n      margin: ",
        "px 0 0 0;\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  top: -20px;\n\n  @media (max-width: 767px) {\n    top: 0;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: ",
        "px;\n\n  p {\n    margin: ",
        "px 0;\n    font-size: 16px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  @media (max-width: 767px) {\n    display: block;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  margin-right: ",
        "px;\n  align-items: center;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-size: 16px;\n  color: ",
        ";\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n\n  &:hover {\n    opacity: 0.8;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var StyledAccountContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-0"
})(_templateObject());
var StyledSecondarySection = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-1"
})(_templateObject1(), _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.MAX_LOYALTY_CONTAINER_WIDTH */ ._.MAX_LOYALTY_CONTAINER_WIDTH, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER * 2);
var StyledLoyaltyContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-2"
})(_templateObject2(), _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.MAX_LOYALTY_CONTAINER_WIDTH */ ._.MAX_LOYALTY_CONTAINER_WIDTH, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.LOYALTY_MENU_HEIGHT_DESKTOP */ ._.LOYALTY_MENU_HEIGHT_DESKTOP, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.LOYALTY_MENU_HEIGHT_MOBILE */ ._.LOYALTY_MENU_HEIGHT_MOBILE);
var StyledFlexedHeader = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-3"
})(_templateObject3());
var StyledTopLevelLoyaltyContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-4"
})(_templateObject4(), _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.LOYALTY_MENU_HEIGHT_DESKTOP */ ._.LOYALTY_MENU_HEIGHT_DESKTOP, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.LOYALTY_MENU_HEIGHT_MOBILE */ ._.LOYALTY_MENU_HEIGHT_MOBILE);
var StyledForm = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].form.withConfig */ .ZP.form.withConfig({
    componentId: "sc-495d45f5-5"
})(_templateObject5());
var StyledInlineFormContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-6"
})(_templateObject6());
var StyledFormField = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-7"
})(_templateObject7(), function(param) {
    var autoHeight = param.autoHeight, theme = param.theme;
    return autoHeight ? "auto" : "".concat(theme.forms.field_height + _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER, "px");
}, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER);
var StyledCancelAndSubmitButtons = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-8"
})(_templateObject8(), _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER);
var StyledInlineCancelAndSubmitButtons = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(StyledCancelAndSubmitButtons).withConfig({
    componentId: "sc-495d45f5-9"
})(_templateObject9());
var StyledContactInfoContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-10"
})(_templateObject10(), _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER / 4);
var StyledContactInfoContent = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-11"
})(_templateObject11());
var StyledCancelEdit = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-12"
})(_templateObject12(), _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER);
var StyledLinkButton = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-495d45f5-13"
})(_templateObject13(), function(param) {
    var bold = param.bold, theme = param.theme;
    return bold ? theme.primary_font.bold.font_family : theme.primary_font.regular.font_family;
}, function(param) {
    var theme = param.theme;
    return theme.global.primary_active_color;
});


/***/ }),

/***/ 9455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ useAccountDispatch; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86879);
/* harmony import */ var _redux_me_actions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47290);



var useAccountDispatch = function() {
    var dispatch = (0,_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        dispatch: dispatch
    }, _redux_me_actions__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [669,513,372,443,593,882,588,373,895,774,888,179], function() { return __webpack_exec__(63312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);